<app-main-navigation></app-main-navigation>
<div class="container">

<nav aria-label="breadcrumb">
    <ol class="breadcrumb  mt-0  mb-0  ps-0  pb-0" style="background-color: transparent;">
        <li class="breadcrumb-item"><a routerLink="/">Dashboard</a></li>
        <li class="breadcrumb-item  active">Users</li>
    </ol>
</nav>

<div *ngIf="!users" class="card  mt-3">
    <div class="card-body">
        <h6 class="card-title  text-muted">Loading users...</h6>

        <div class="progress" style="height: 10px;">
            <div class="progress-bar  progress-bar-striped  progress-bar-animated" role="progressbar"
                 style="width: 100%; background-color: rgba(127,127,127,0.98);"></div>
        </div>
    </div>
</div>

<div *ngIf="users" class="card  mt-3">
    <div class="card-body">
        <h5 class="card-title">
            Users
        </h5>

        <div>
            <form (ngSubmit)="onSearch()" #searchForm="ngForm" novalidate>

            <div class="mt-3 p-3 bg-dark-subtle d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-end gap-2" >
                    <div>
                        <label class="form-label">Søgning:</label>
                        <input class="form-control" [(ngModel)]="paginationData.searchQuery" name="text">
                    </div>
                    <div>
                        <label class="form-label"> &nbsp; </label>
                        <button class="btn btn-primary">Søg</button>
                    </div>
                </div>

                <button routerLink="/user" class="btn  btn-sm  btn-secondary  float-right">Add user</button>

            </div>
            </form>
        </div>
        <table *ngIf="users" class="table">
            <thead>
            <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Group</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of users">
                <td>
                    <a
                       routerLink="/user/{{ user.uuid }}">{{user?.name}}</a>
                </td>
                <td>
                    {{user?.username}}
                </td>
                <td>
                    {{user?.group?.name}}
                </td>
                <td>
                    <a (click)="deleteUser(user)" class="TenFour-button  btn btn-custom">

                    <i
                            class="fa fa-trash"></i>
                    </a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
</div>
